// DS: CR03A, CR03B
import React from 'react';
import classnames from 'classnames';
import UserAvatar from '@wix/da-shared-react/pkg/User/Avatar';
import UserLink from '@wix/da-shared-react/pkg/User/Link';
import { PapiUser } from '@wix/da-types-papi';

import s from './MiniProfileIdentity.scss';

export interface Props {
  user: PapiUser;
  view?: 'default' /* CR03A */ | 'contrasting' /* CR03B */;
  className?: string;
  usernameClassName?: string;
  withTooltip?: boolean;
}

export const MiniProfileIdentity: React.FC<Props> = ({
  user,
  view = 'default',
  withTooltip = false,
  className,
  usernameClassName,
}) => (
  <div className={classnames(s['root'], s[`view-${view}`], className)}>
    <UserLink
      user={user}
      className={s['content-wrapper']}
      contentClassName={s['content']}
      withTooltip={withTooltip}
    >
      <UserAvatar
        user={user}
        className={s['user-avatar']}
        withLink={false}
      />
      <span className={classnames(s['user-name'], usernameClassName)}>
        {user.username}
      </span>
    </UserLink>
  </div>
);
MiniProfileIdentity.displayName = 'MiniProfileIdentity';

export default MiniProfileIdentity;
